export default __webpack_public_path__ + "static/media/icon_comments.dd698646.svg";